let ctx: AudioContext | null = null;

function ensureCtx(): AudioContext | null {
  if (ctx) return ctx;
  try {
    ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
    return ctx;
  } catch {
    return null;
  }
}

/** Called on first user gesture (e.g., canvas click) to unlock audio. */
export function unlockAudio() {
  const c = ensureCtx();
  if (!c) return;
  if (c.state === "suspended") void c.resume();
}

export type SfxName = "beep" | "go" | "shieldActivate" | "deflect" | "hit";

export function playSfx(name: SfxName) {
  const c = ensureCtx();
  if (!c) return;
  switch (name) {
    case "beep":
      beep(c, 880, 0.08, "square");
      return;
    case "go":
      beep(c, 1320, 0.18, "square");
      return;
    case "shieldActivate":
      sweep(c, 600, 1200, 0.12, "sine");
      return;
    case "deflect":
      sweep(c, 400, 1800, 0.25, "sawtooth");
      return;
    case "hit":
      beep(c, 110, 0.18, "square", 0.4);
      return;
  }
}

function beep(c: AudioContext, freq: number, durSec: number, type: OscillatorType, gainPeak = 0.18) {
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  osc.connect(g).connect(c.destination);
  const now = c.currentTime;
  g.gain.setValueAtTime(0, now);
  g.gain.linearRampToValueAtTime(gainPeak, now + 0.01);
  g.gain.exponentialRampToValueAtTime(0.001, now + durSec);
  osc.start(now);
  osc.stop(now + durSec + 0.02);
}

function sweep(c: AudioContext, fStart: number, fEnd: number, durSec: number, type: OscillatorType) {
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(fStart, c.currentTime);
  osc.frequency.exponentialRampToValueAtTime(fEnd, c.currentTime + durSec);
  osc.connect(g).connect(c.destination);
  g.gain.setValueAtTime(0, c.currentTime);
  g.gain.linearRampToValueAtTime(0.18, c.currentTime + 0.01);
  g.gain.exponentialRampToValueAtTime(0.001, c.currentTime + durSec);
  osc.start(c.currentTime);
  osc.stop(c.currentTime + durSec + 0.02);
}
